import { onFinishMultiAction } from '../Widget/actions';

export const completeGlobalFallbackMultiAction = actionIdentifier => dispatch =>
	{
		onFinishMultiAction(actionIdentifier)(dispatch);
	}